import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { imgUrl, money } from "@/lib/api";

export function ProductCard({ product, index = 0 }) {
  const img = (product.images || [])[0];
  const onSale = product.sale_price && product.sale_price < product.price;
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.45, delay: Math.min(index * 0.06, 0.4) }}
    >
      <Link to={`/product/${product.slug}`} className="group block" data-testid={`product-card-${product.slug}`}>
        <div className="relative overflow-hidden rounded-xl bg-white aspect-[4/5]">
          {img ? (
            <img
              src={imgUrl(img)}
              alt={product.name}
              loading="lazy"
              className="h-full w-full object-contain transition-transform duration-500 ease-out group-hover:scale-105"
            />
          ) : (
            <div className="h-full w-full flex items-center justify-center text-muted-foreground text-sm">No image</div>
          )}
          <div className="absolute top-3 left-3 flex gap-2">
            {product.featured && <Badge className="bg-primary text-primary-foreground rounded-full" data-testid={`featured-badge-${product.slug}`}>Featured</Badge>}
            {(!product.in_stock || product.stock === 0) && <Badge variant="secondary" className="rounded-full" data-testid={`outofstock-badge-${product.slug}`}>Out of stock</Badge>}
          </div>
        </div>
        <div className="pt-4">
          <h3 className="font-display text-lg leading-snug group-hover:text-primary transition-colors">{product.name}</h3>
          <p className="mt-1 text-sm">
            {onSale ? (
              <>
                <span className="font-semibold text-primary">{money(product.sale_price)}</span>{" "}
                <span className="line-through text-muted-foreground ml-1">{money(product.price)}</span>
              </>
            ) : (
              <span className="font-semibold">{money(product.price)}</span>
            )}
          </p>
        </div>
      </Link>
    </motion.div>
  );
}
